export default function TermsPage() {
  return (
    <div data-testid="page-terms" className="bg-[#F9F8F6]">
      <section className="max-w-4xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-24">
        <div className="text-xs uppercase tracking-[0.3em] text-[#8E6A2B] mb-6">— Terms</div>
        <h1 className="font-serif text-5xl md:text-6xl text-[#0F292F] font-light tracking-tight leading-[1.05]">
          Terms of Service
        </h1>
        <p className="mt-6 text-sm text-[#52525B]">Effective: December 2025</p>

        <div className="mt-12 space-y-10 text-[#1A1A1A] leading-relaxed">
          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">1. Agreement to These Terms</h2>
            <p>
              These Terms of Service ("Terms") govern your use of the website located at
              https://helliotassociates.com and any related pages or subdomains (collectively, the
              "Site") operated by H. Elliot Associates, LLC ("the firm," "we," "our," or "us").
              By accessing the Site, submitting a form, booking a consultation, creating a client
              portal account, or purchasing any service, you agree to be bound by these Terms and
              our Privacy Policy.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">2. Description of Services</h2>
            <p>
              The firm provides tax preparation, tax planning, retirement planning, and IRS
              representation services under the principal's federal Enrolled Agent (EA) licensure
              with the U.S. Internal Revenue Service. The firm does <strong>not</strong> currently
              provide investment-adviser services and is <strong>not</strong> registered as an
              investment adviser with the SEC or any state securities authority. See the{" "}
              <a href="/disclosures" className="underline text-[#0F292F]">Disclosures</a> page for
              the full scope of current licensure.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">3. Engagement</h2>
            <p>
              Personalized tax, retirement, or representation services are provided only under
              a written engagement letter executed between you and the firm. Use of this Site,
              submission of a contact or booking form, or creation of a client portal account
              does not, by itself, create an advisor–client relationship. No such relationship
              exists until an engagement letter is signed and any required retainer is received.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">4. Fees and Payment</h2>
            <p>
              Fees for engagements are set forth in each engagement letter. Payment may be
              accepted by ACH bank transfer, credit or debit card, or other methods the firm
              makes available from time to time. Online payments are processed by Stripe, Inc.,
              under Stripe's own terms of service and privacy policy. The firm does not store
              full credit-card numbers on its servers.
            </p>
            <p className="mt-3">
              Invoices are due on receipt unless otherwise stated. Past-due balances may accrue
              interest at the lesser of 1.0% per month or the maximum rate permitted by
              Maryland law.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">5. Cancellations & Refunds</h2>
            <p>
              Please see our separate{" "}
              <a href="/refunds" className="underline text-[#0F292F]">Refund Policy</a> for
              full details on cancellations, rescheduling, and refunds for consultations,
              retainers, and completed work.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">6. Client Portal</h2>
            <p>
              If you create an account on our client portal, you are responsible for
              maintaining the confidentiality of your login credentials and for all activity
              that occurs under your account. Notify us immediately at
              helliotassociates@gmail.com if you suspect unauthorized access.
            </p>
            <p className="mt-3">
              Do not upload documents that include full Social Security numbers in plaintext
              file names, plaintext passwords, or any content you are not legally permitted to
              share.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">7. Accuracy of Information You Provide</h2>
            <p>
              The firm relies on the accuracy and completeness of information you provide.
              Inaccurate, incomplete, or untimely information may result in errors on your
              return, assessments of additional tax, penalties, or interest — for which the
              firm is not responsible.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">8. No Guarantee of Outcome</h2>
            <p>
              Tax positions, IRS representation outcomes, and retirement-planning results depend
              on facts, law, and regulatory discretion that are outside the firm's control. The
              firm makes no guarantee of any particular refund amount, audit result, penalty
              abatement, settlement, or financial outcome.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">9. Intellectual Property</h2>
            <p>
              All content on this Site — text, graphics, logos, and layouts — is the property
              of H. Elliot Associates, LLC or its licensors and is protected by U.S. and
              international copyright and trademark law. You may view and print content for
              personal, non-commercial use only.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">10. Third-Party Links</h2>
            <p>
              The Site may link to third-party websites. We do not control, endorse, or accept
              responsibility for their content, policies, or practices. Use of any third-party
              site is at your own risk.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">11. Disclaimer of Warranties</h2>
            <p>
              The Site and its content are provided on an "as-is" and "as-available" basis.
              To the fullest extent permitted by law, the firm disclaims all warranties, express
              or implied, including warranties of merchantability, fitness for a particular
              purpose, and non-infringement.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">12. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, the firm's total liability to you in
              connection with any engagement or use of the Site shall not exceed the fees
              actually paid by you to the firm for the specific engagement giving rise to the
              claim. In no event shall the firm be liable for indirect, incidental,
              consequential, special, or punitive damages.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">13. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless H. Elliot Associates, LLC and its
              principal from any claim, loss, liability, or expense (including reasonable
              attorneys' fees) arising from your breach of these Terms, your misuse of the
              Site, or your submission of inaccurate information.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">14. Governing Law</h2>
            <p>
              These Terms are governed by the laws of the State of Maryland, without regard to
              its conflict-of-laws rules. Any dispute arising under these Terms or out of any
              engagement shall be resolved exclusively in the state or federal courts located
              in Montgomery County, Maryland, and you consent to personal jurisdiction there.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">15. Changes to These Terms</h2>
            <p>
              We may update these Terms from time to time. Material changes will be posted to
              this page with an updated effective date. Continued use of the Site after
              changes take effect constitutes acceptance of the revised Terms.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">16. Contact</h2>
            <p>
              Questions about these Terms may be directed to helliotassociates@gmail.com or
              (571) 598-5790. Mailing address: H. Elliot Associates, LLC, 451 N. Hungerford Dr.,
              Suite 119, Rockville, MD 20850.
            </p>
          </section>
        </div>
      </section>
    </div>
  );
}
